<div
  class="select-field"
  [class.select-field--error]="error()"
  [class.select-field--disabled]="disabled()"
  (focusout)="onFocusOut($event)"
>
  @if (label()) {
    <label [id]="labelId()" [for]="id()" class="select-field__label">{{ label() }}</label>
  }

  <div
    class="select-field__wrapper"
    [class.select-field__wrapper--open]="isOpen()"
    [class.select-field__wrapper--error]="error()"
  >
    <button
      type="button"
      [id]="id()"
      class="select-field__trigger"
      [attr.aria-haspopup]="'listbox'"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-labelledby]="label() ? labelId() + ' ' + id() : null"
      [disabled]="disabled()"
      (click)="toggleOpen()"
      (keydown)="onTriggerKeydown($event)"
    >
      <span
        class="select-field__value"
        [class.select-field__value--placeholder]="!selectedLabel()"
      >
        {{ selectedLabel() || placeholder() }}
      </span>
      <span class="select-field__chevron" aria-hidden="true">
        <app-icon [icon]="chevronIcon" [size]="16" />
      </span>
    </button>

    @if (isOpen()) {
      <ul
        class="select-field__listbox"
        role="listbox"
        [attr.aria-label]="label() || 'Opciones'"
      >
        @for (opt of options(); track opt.value; let i = $index) {
          <li
            class="select-field__option"
            [class.select-field__option--selected]="opt.value === value()"
            [class.select-field__option--active]="activeIndex() === i"
            role="option"
            tabindex="-1"
            [attr.aria-selected]="opt.value === value()"
            (click)="selectOption(opt.value)"
            (mouseenter)="activeIndex.set(i)"
          >
            {{ opt.label }}
          </li>
        }
      </ul>
    }
  </div>

  @if (error()) {
    <span class="select-field__error" role="alert">{{ error() }}</span>
  }
</div>
